import { Controller } from "@hotwired/stimulus";

// Alarm events come from selecting alarms, not from event checkboxes.
const ALARM_INPUTS = {
  alarm_alert: "channel[alarm_alert_ids][]",
  alarm_ok: "channel[alarm_ok_ids][]",
};

// Keeps the WebSocket integration's "token needs" list in step with the
// form, mirroring Channels::WebSocket#required_permissions.
export default class extends Controller {
  static targets = ["list"];
  static values = { permissions: Object };

  connect() {
    this.refresh();
  }

  refresh() {
    const events = [
      ...document.querySelectorAll('input[name="channel[events][]"]:checked'),
    ].map((input) => input.value);

    for (const [event, name] of Object.entries(ALARM_INPUTS)) {
      if (document.querySelector(`input[name="${name}"]:checked`)) {
        events.push(event);
      }
    }

    const scopes = new Set(["integrations:read"]);
    for (const event of events) {
      if (this.permissionsValue[event])
        scopes.add(this.permissionsValue[event]);
    }

    this.listTarget.replaceChildren(
      ...[...scopes].map((scope) => {
        const code = document.createElement("code");
        code.textContent = scope;
        return code;
      }),
    );
  }
}
